import notificationService from 'Services/NotificationService'

// initial state
const state = {
  isFetching: false,

  notifications: [],
  userNotifications: [],

  totalUnreadCount: 0
}

// getters
const getters = {
  notification: state => reference => state.notifications.find(notification => notification.reference === reference),
  userNotification: state => reference => state.userNotifications.find(notification => notification.reference === reference)
}

const actions = {
  filterNotifications: ({ commit }, { filterContext }) => {
    const { request, cancelToken } = notificationService.getAll(filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setNotifications', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getNotifications: ({ dispatch }) => {
    return dispatch('filterNotifications').then(({ promise }) => promise.then(result => result.data))
  },

  getNotification: ({ state, commit }, { reference }) => {
    return new Promise((resolve, reject) => {
      notificationService.get(reference).then(result => {
        commit(state.notifications.some(item => item.reference === result.reference) ? 'updateNotification' : 'setNotification', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addNotification: ({ commit }, { notification }) => {
    return new Promise((resolve, reject) => {
      notificationService.add(notification).then((result) => {
        commit('setNotification', result)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateNotification: ({ dispatch }, { reference, notification }) => {
    return new Promise((resolve, reject) => {
      notificationService.update(reference, notification).then(() => {
        return dispatch('getNotification', { reference }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteNotification: ({ commit }, { reference }) => {
    return new Promise((resolve, reject) => {
      notificationService.delete(reference).then(() => {
        commit('deleteNotification', reference)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  filterUserNotifications: ({ commit }, { filterContext }) => {
    const { request, cancelToken } = notificationService.getUserNotifications(filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setUserNotifications', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getUserNotifications: ({ dispatch }) => {
    return dispatch('filterUserNotifications').then(({ promise }) => promise.then(result => result.data))
  },

  getUserNotification: ({ state, commit }, { reference }) => {
    return new Promise((resolve, reject) => {
      notificationService.getUserNotification(reference).then(result => {
        commit(state.userNotifications.some(item => item.reference === result.reference) ? 'updateUserNotification' : 'setUserNotification', result)

        if (result.unread) {
          commit('setNotificationProperty', { property: 'totalUnreadCount', value: state.totalUnreadCount - 1 })
        }

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getUserNotificationStatus: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      if (state.isFetching === false) {
        commit('setNotificationProperty', { property: 'isFetching', value: true })

        return notificationService.getUserNotificationStatus().then((result) => {
          commit('setNotificationProperty', { property: 'totalUnreadCount', value: result.totalUnreadCount })

          resolve({ notification: result.data, totalUnreadCount: result.totalUnreadCount, passwordExpiresInXDays: result.passwordExpiresInXDays })
        }).catch(error => {
          reject(error)
        }).finally(() => {
          commit('setNotificationProperty', { property: 'isFetching', value: false })
        })
      } else {
        resolve()
      }
    })
  }
}

// mutations
const mutations = {
  setNotifications (state, notifications) {
    state.notifications = notifications
  },

  setNotification (state, notification) {
    state.notifications.push(notification)
  },

  updateNotification (state, notification) {
    state.notifications = state.notifications.map(item =>
      item.reference === notification.reference ? notification : item
    )
  },

  deleteNotification (state, reference) {
    state.notifications = state.notifications.filter(notification => notification.reference !== reference)
  },

  setUserNotifications (state, notifications) {
    state.userNotifications = notifications
  },

  setUserNotification (state, notification) {
    state.userNotifications.push(notification)
  },

  updateUserNotification (state, notification) {
    state.userNotifications = state.userNotifications.map(item =>
      item.reference === notification.reference ? notification : item
    )
  },

  setNotificationProperty (state, { property, value }) {
    state[property] = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
